<template>
  <div class="border-bg about">
    <div class="title-style">
      <div class="title-box">关于武安</div>
    </div>

      <div class="video-container">
        <vue3-seamless-scroll :list="list" class="scroll" :step="0.3">
          <div class="item" v-for="item in list " :key="item">
            武安是粟的发祥地、黍的起源地、小米的故乡，有着数千年的谷物种植历史，“武安小米”作为国家地理标志保护产品，不仅走进了北京、上海等城市，而且飘洋过海远销东南亚。
    近年来，武安市依托河北省农科院谷子研究所的技术指导，示范推广优质专用谷子新品种和有机、绿色无公害栽培技术，紧抓龙头企业建设、基地建设、优种供应、试验示范、标准化生产，促进小米生产规模化、产业化，延伸产业链条，为小米产业发展增添了后劲。
    在现今大数据与“互联网+”的时代背景下，指数监测作为产业数字化的一种具体表现形式，以其特有的优势，成为了一种新的发展趋势。作为大数据采集、分析、应用最直观的表现形式，指数的建立运用，能有效对产业大数据进行积累沉淀，深度挖掘数据价值。
    基于以上背景，为贯彻落实国家数字经济发展战略，配合《河北省数字经济发展规划（2020-2025年）》及《关于支持数字经济加快发展的若干政策》等相关政策的实施，紧紧抓住产业数字化、数字产业化赋予的机遇，编制“武安小米产业指数”，更准确地反映武安小米产业的发展趋势和变化规律，助力武安市持续壮大发展现代特色农业，加快小米精深加工全产业链开发，创建省级精品谷子示范基地。
          </div>
        </vue3-seamless-scroll>
      </div>

  </div>
</template>

<script setup>
import { ref } from 'vue'
const list = ref([1, 2, 5, 4, 5, 4, 4])
</script>

<style lang="scss" scoped>
.about{
  margin-right: 0;
  padding: 5px;
  .video-container{
    margin: 10px 0;
    height: 225px;
    line-height: 25px;
    text-indent: 2em;
    text-align: justify;
    overflow-y: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-color: transparent transparent;
    scrollbar-track-color: transparent;
    -ms-scrollbar-track-color: transparent;
    &::-webkit-scrollbar {
      display: none;
    }

    .item{
      margin-bottom: 10px;
    }
  }
}
</style>
